import { useQuery } from '@tanstack/react-query';
import { fetchDistinctGenres } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

export function useEventGenres() {
  return useQuery({
    queryKey: queryKeys.genres(),
    queryFn: fetchDistinctGenres,
    staleTime: STALE.static,
    select: (data) => {
      const primary = data.filter((r) => r.is_primary).map((r) => r.genre);
      const secondary = data.filter((r) => !r.is_primary).map((r) => r.genre);
      return {
        primaryGenres: ['All Genres', ...primary],
        secondaryGenres: secondary,
      };
    },
  });
}
